import {useEffect} from 'react';
import classNames from 'classnames';
import ReactPortal from './ReactPortal';
import {IoMdClose} from 'react-icons/io';

const modalWidth = {
  md: 'max-w-[40%]',
  lg: 'max-w-[60%]',
  xl: 'max-w-[90%]',
};

function Modal({
  children,
  isOpen,
  onClose,
  containerClassName,
  title = null,
  wrapperId = 'modal',
  width = 'md',
}) {
  useEffect(() => {
    const closeOnEscapeKey = (e) => (e.key === 'Escape' ? onClose() : null);
    document.body.addEventListener('keydown', closeOnEscapeKey);

    return () => {
      document.body.removeEventListener('keydown', closeOnEscapeKey);
    };
  }, []);

  // useEffect(() => {
  //   const body = document.querySelector('body');
  //   body.style.overflow = isOpen ? 'hidden' : 'unset';
  //   () => {
  //     body.style.overflow = 'unset';
  //   };
  // }, [isOpen]);

  if (!isOpen) return null;

  return (
    <ReactPortal wrapperId={wrapperId}>
      <div className="fixed top-0 left-0 h-full w-screen bg-[#00000096] z-20">
        <div
          onClick={onClose}
          role="modal-overlay"
          className="h-full w-full z-[25]"
        />
        <div
          className={classNames(
            'absolute-center bg-white min-w-1/2 p-5 z-30 overflow-auto max-h-full w-full rounded-[5px]',
            containerClassName || modalWidth[width],
          )}
        >
          <div
            className={classNames(
              'flex pb-3 p-4',
              title ? 'justify-between min-w-[300px]' : 'justify-end',
            )}
          >
            <div className="flex item">
              <div className="font-semibold text-xl">{title}</div>
            </div>
            <button
              aria-label="close-modal"
              onClick={onClose}
              className="close-btn"
            >
              <IoMdClose size={30} color="red" />
            </button>
          </div>
          <div role="dialog">{children}</div>
        </div>
      </div>
    </ReactPortal>
  );
}

export default Modal;
